import { type ActorRefFromLogic } from "xstate";

import { LOCAL_WORKSPACE_NAME } from "~/state/types";
import { docsApiFetch, getDocsApiUrl } from "~/utils/docsapi";

import { type AuthenticationMachine, waitForAccessTokenSilently } from "../authentication";

export const hasSharePermissionPromise = async ({
	input,
}: {
	input: {
		documentId: string;
		publishWorkspace: string | unknown;
		authenticationActorRef: ActorRefFromLogic<AuthenticationMachine>;
	};
}): Promise<boolean> => {
	const { documentId, publishWorkspace, authenticationActorRef } = input;
	if (!publishWorkspace) {
		return false;
	}

	const token = await waitForAccessTokenSilently(authenticationActorRef);
	if (!token) {
		return false;
	}

	if (publishWorkspace === LOCAL_WORKSPACE_NAME) {
		return false;
	}

	const response = await docsApiFetch(token, false)(
		`${getDocsApiUrl()}/internal/v1/permissions/${publishWorkspace}/${documentId}?permission=share`,
		{ method: "GET" }
	);

	if (response.ok) {
		return true;
	} else if (response.status == 403 || response.status == 404) {
		return false;
	}

	throw new Error(response.statusText, { cause: response });
};
